
import { Quest, QuestCategory } from '../../../types';

export const SKATER_APPRENTICE_QUESTS: Quest[] = [
  {
    id: 2000,
    category: QuestCategory.SkillBuilder,
    title: 'Safety First, Fun Second',
    questlineId: 'skater-apprentice',
    isQuestlineStart: true,
    description: 'Your skateboarding journey begins with the most important skill: safety. Let\'s get geared up.',
    details: 'Before you even step on the board, learn to put on your safety gear correctly. That means helmet, wrist guards, elbow pads, and knee pads. A safe skater is a smart skater.'
  },
  {
    id: 2001,
    category: QuestCategory.Explorer,
    title: 'Finding Your Stance',
    questlineId: 'skater-apprentice',
    prerequisiteQuestId: 2000,
    description: 'Every skater is either "regular" or "goofy". Let\'s find out which one you are.',
    details: 'On a safe surface like grass or a rug (so the board doesn\'t roll), practice standing on the skateboard. Figure out which foot feels more natural to have at the front. Left foot forward is "regular", right foot forward is "goofy". There\'s no wrong answer!'
  },
  {
    id: 2002,
    category: QuestCategory.Explorer,
    title: 'The First Push',
    questlineId: 'skater-apprentice',
    prerequisiteQuestId: 2001,
    description: 'You have your gear and your stance. It\'s time for your first real roll.',
    details: 'Find a smooth, flat, open area with no traffic. With your front foot on the board over the bolts, use your back foot to give a gentle push. Then, bring your back foot onto the board and try to balance as you glide.'
  },
  {
    id: 2003,
    category: QuestCategory.Explorer,
    title: 'The Gentle Turn',
    questlineId: 'skater-apprentice',
    prerequisiteQuestId: 2002,
    description: 'Now that you can roll, let\'s learn to steer. This is called "carving".',
    details: 'As you are rolling, practice gently leaning your weight onto your toes to turn one way, and then onto your heels to turn the other way. This is the key to controlling the board.'
  },
  {
    id: 2004,
    category: QuestCategory.Explorer,
    title: 'The Confident Cruise',
    questlineId: 'skater-apprentice',
    prerequisiteQuestId: 2003,
    description: 'Let\'s put it all together. Go for a short, continuous cruise.',
    details: 'In your safe area, your mission is to go for a 5-minute cruise. Practice pushing, gliding, and carving gentle turns. The goal is to feel comfortable and confident just riding your board.'
  },
  {
    id: 2005,
    category: QuestCategory.SkillBuilder,
    title: 'The Ollie Prep',
    questlineId: 'skater-apprentice',
    prerequisiteQuestId: 2004,
    description: 'The Ollie is the most important trick in skateboarding. Let\'s learn the basic footwork on grass.',
    details: 'On grass so your board won\'t roll, practice the two key motions of an ollie: "popping" the tail down with your back foot, and "sliding" your front foot up the board. This is a tricky skill that takes a lot of practice!',
    youtubeId: 'He6yqJgH4a0'
  }
];
